<template>
  <div id="app">

    <transition name="fade">
      <router-view  v-if="isRouterAlive"/>
    </transition>
    <div class="loading-box" v-if="isLoading">
      <nt-pulse-loader :loading="isLoading"></nt-pulse-loader>
    </div>
    <transition name="el-zoom-in-center">
      <nt-preview-image v-if="previewImgUrl"></nt-preview-image>
    </transition>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'App',
    computed:{
      ...mapState(['isLoading','previewImgUrl'])
    },
    provide(){
      return{
        reload:this.reload
      }
    },
    data(){
      return {
        isRouterAlive:true,
      }
    },
    methods:{
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        })
      }
    }
  }
</script>

<style>
  #app {
    height: 100%;
    text-align: center;
    color: #000;

  }
</style>



// WEBPACK FOOTER //
// App.vue?1b27a24d